import { Box, MenuItem, Select, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { ConfigTabState, takesSpotReference } from "../types";
import { formatDeliveryWindow } from "../../../deliveryWindow";
import { find } from "../../orderBook/allGrids";
import { usePrefillContext } from "../../../Services/PrefillContextProvider";

export const ProductNameField = () => {
  const { values, errors } = useFormikContext<ConfigTabState>();
  const product = values.product_definition;

  return (
    <ReadOnlyField
      label="Product"
      value={
        formatDeliveryWindow(product?.delivery_start, product?.delivery_end) ??
        product?.product_name
      }
      error={errors.product_definition?.product_name}
    />
  );
};

export const GridField = () => {
  const { values, errors, setFieldValue } = useFormikContext<ConfigTabState>();
  const { selectContractArea, prefill } = usePrefillContext();
  const product = values.product_definition;
  const options = product?.grid_options ?? [];
  const error = errors?.product_definition?.grid;

  if (options.length > 1) {
    return (
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <FieldLabel label="Grid" error={error} />
        <Select
          value={product.grid}
          onChange={(event) => {
            const grid = event.target.value;
            setFieldValue("product_definition.grid", grid);
            setFieldValue(
              "product_definition.display_grid",
              find(grid).displayName
            );
            selectContractArea(grid);
            // Coupled areas can clear at different spot prices, and the
            // reference follows the area the algo will actually trade in.
            if (prefill !== undefined && takesSpotReference(values)) {
              setFieldValue(
                "reference_price",
                prefill.spotByArea[grid]?.yenPerKwh
              );
            }
          }}
          variant="standard"
          disableUnderline
          sx={{
            width: "100%",
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1.35,
            color: error ? "error.main" : "text.primary",
            "& .MuiSelect-select": {
              padding: 0,
              paddingRight: "16px !important",
              minHeight: "unset",
            },
            "& .MuiSelect-icon": { fontSize: 14, right: 0 },
          }}
        >
          {options.map((code) => (
            <MenuItem key={code} value={code} sx={{ fontSize: 12 }}>
              {find(code).displayName}
            </MenuItem>
          ))}
        </Select>
      </Box>
    );
  }

  return (
    <ReadOnlyField label="Grid" value={product?.display_grid} error={error} />
  );
};

const FieldLabel = (props: { label: string; error: string | undefined }) => (
  <Typography
    sx={{
      fontSize: 9,
      lineHeight: 1.2,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      color: props.error ? "error.main" : "text.secondary",
    }}
  >
    {props.label}
  </Typography>
);

const ReadOnlyField = (props: {
  label: string;
  value: string | undefined;
  error: string | undefined;
}) => {
  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <FieldLabel label={props.label} error={props.error} />
      <Typography
        noWrap
        title={props.value ?? ""}
        sx={{
          fontSize: 12,
          lineHeight: 1.35,
          fontWeight: 600,
          color: props.error ? "error.main" : "text.primary",
        }}
      >
        {props.value || "—"}
      </Typography>
    </Box>
  );
};
